import {type} from "@codeArt/utils/common";
import React from "react";

const _internalColors = [
  "default",
  "primary",
  "secondary",
  "success",
  "danger",
  "warning",
  "info",
  "light",
  "dark",
  "blue",
  "white"
];
const _extensionColors = [
  "cyan",
  "teal",
  "amber",
  "orange",
  "deep-orange",
  "red",
  "pink",
  "light-blue",
  "indigo",
  "lime",
  "light-green",
  "purple",
  "deep-purple",
  "green",
  "grey",
  "blue-grey",
  "black",
  "light-grey",
  "disabled"
];
const _metronicColors = [
  "m-text-muted",
  "m-text-primary",
  "m-text-success",
  "m-text-danger",
  "m-text-dark-75",
  "m-text-dark-50",
  "m-bg-primary",
  "m-bg-success",
  "m-bg-danger",
  "m-bg-warning",
  "m-bg-light",
  "m-bg-muted",
  "m-bg-dark-75",
  "m-bg-light-primary",
  "m-bg-light-success",
  "m-bg-light-danger",
  "m-bg-light-dark-75",
  "m-bg-light-dark-50",
  "m-bg-light-info"
]; //以后补全
export function getThemeColor(name, type){
  if (!type) type = "text";

  if (type === "value") {
    return theme.color[name] || name;
  }

  if (_internalColors.indexOf(name) > -1) {
    return `${type}-${name}`;
  }

  if (_extensionColors.indexOf(name) > -1) {
    return `c-${type}-${name}`;
  }
  if (_metronicColors.indexOf(name) > -1) {
    return name;
  }
  return "";
}

export const theme = {
  color: {
    default: "#252525",
    blue: "#2196F3",
    deepBlue: "rgb(0, 123, 255)",
    // indigo: '#6610f2',
    purple: "#6f42c1",
    pink: "#e83e8c",
    red: "#dc3545",
    orange: "#fd7e14",
    yellow: "#ffc107",
    green: "#28a745",
    teal: "#20c997",
    cyan: "#17a2b8",
    white: "#fff",
    gray: "#6c757d",
    primary: "#3f51b5",
    secondary: "#ff4081",
    success: "#28a745",
    info: "#00bcd4",
    warning: "#ffb822",
    danger: "#dc3545",
    light: "#f8f9fa",
    dark: "#343a40",
    indigo: "#3f51b5",
    secondaryDark: "#ff4081",
    amber: "#ffc107",
    favorite: "#ff3d47",
    line: "#e6e6e6",
    "grey-system": "#bdbdbd",
    "bar-green": "#9fdabf",
    "r-green": "rgb(0, 196, 159)",
    "r-orange": "rgb(255, 128, 66)",
    "light-grey": "#ccc",
    "light-blue": "#03a9f4",
    "light-primary": "#e4e7f6",
    "m-success": "#0abb87 ",
    "m-warning": "#ffb822 ",
    "m-danger": "#fd397a ",
    "m-info": "#5578eb ",
    "m-primary": "#5867dd ",
    "m-brand": "#5d78ff ",
    "m-dark": "#282a3c ",
    "m-light": "#f3f6f9",
    "m-muted": "#b5b5c3",
    "m-text-muted": "#b5b5c3",
    "m-text-dark75": "#464e5f",
    "m-text-dark-75": "#464e5f",
    "m-text-dark50": "#80808f",
    "m-text-dark-50": "#80808f",
    "m-bg-light-info": "#eee5ff",
    "m-bg-light-primary": "#e1e9ff"
  }
};

export function getThemeColorValue(name){
  return name ? theme.color[name] : null;
}

const multicolor = [
  "blue",
  "purple",
  "pink",
  "red",
  "orange",
  "yellow",
  "green",
  "teal",
  "cyan",
  "primary",
  "info",
  "light-blue"
];

//循环获取颜色
export function getLoopMulticolorValue(index, colors){
  colors = colors || multicolor;
  let i = index % colors.length;
  return getThemeColorValue(colors[i]);
}

//数组洗牌算法
function shuffleArray(array){
  var m = array.length,
    t,
    i;
  while (m) {
    i = Math.floor(Math.random() * m--);
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }
  return array;
}

//随机获取颜色数组
export function getRandomMulticolors(){
  return shuffleArray(multicolor.slice());
}

export function usingRandomMulticolorValue(action, max){
  let colors = getRandomMulticolors();
  for (let i = 0; i < max; i++) {
    let color = getLoopMulticolorValue(i, colors);
    action(color, i);
  }
}

export function fillThemeColor(props, color, ignoreProp){
  //ignoreProp是否忽略为属性设置color,就是填充的背景色，如有其他需求，请用getThemeColor
  if (!color) return props;
  if (_internalColors.indexOf(color) > -1) {
    if (ignoreProp) {
      props.className = `bg-${color} ${props.className}`;
    } else props.color = color;
    return props;
  }

  if (_extensionColors.indexOf(color) > -1) {
    props.className = `c-bg-${color} ${props.className}`;
    return props;
  }

  if (_metronicColors.indexOf(color) > -1) {
    props.className = `${color} ${props.className}`;
    return props;
  }

  //编码色
  if (
    testCodedColor(color) == false // 不是正确的编码色格式，则默认为灰色
  )
    color = theme.color["grey-system"];
  props.style = {...props.style, backgroundColor: color};
  return props;
}

// 检查编码色的格式是否正确
function testCodedColor(color){
  var re1 = /^#([0-9a-f]{6}|[0-9a-f]{3})$/i;
  var re2 = /^rgb\(([0-9]|[0-9][0-9]|25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9])\,([0-9]|[0-9][0-9]|25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9])\,([0-9]|[0-9][0-9]|25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9])\)$/i;
  var re3 = /^rgba\(([0-9]|[0-9][0-9]|25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9])\,([0-9]|[0-9][0-9]|25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9])\,([0-9]|[0-9][0-9]|25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9])\,(1|1.0|0.[0-9])\)$/i;
  return re2.test(color) || re1.test(color) || re3.test(color);
}
